import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=4d57b71e&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=4d57b71e&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./TagsView.vue?vue&type=style&index=1&id=4d57b71e&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57b71e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d57b71e')) {
      api.createRecord('4d57b71e', component.options)
    } else {
      api.reload('4d57b71e', component.options)
    }
    module.hot.accept("./TagsView.vue?vue&type=template&id=4d57b71e&scoped=true", function () {
      api.rerender('4d57b71e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/components/TagsView.vue"
export default component.exports